import { Heading } from '@chakra-ui/react';

export function SectionTitle({ children, ...props }) {
  return (
    <Heading fontFamily="Montserrat" fontSize={'12pt'} {...props}>
      {children}
    </Heading>
  );
}
